import axios from 'axios';
import { JobApplication } from '../dtos/jobApplication';
import { getApiV1Url } from '../utils/api';

export async function saveJobApplication(jobApplication: JobApplication): Promise<JobApplication> {
  const { data } = await axios.post<JobApplication>(`${getApiV1Url()}/job-applications`, jobApplication);

  return data;
}
